<div (click)="openModalIfLink($event)" [innerHTML]="content | finSafe: 'html'"></div>

<fcom-modal class="rich-text-modal" [buttons]="ModalButtons.DONE" [(open)]="modalOpen">
  <cms-unstyled-fragment
    *ngIf="cmsUrl"
    class="block pr-large"
    [contentUrl$]="cmsUrl | finToObservable"
  ></cms-unstyled-fragment>
</fcom-modal>
